































































































import { Component, Vue } from "vue-property-decorator";
import productoModule from "@/store/modules/producto-module";

@Component
export default class ScrapingProductos extends Vue {
  proceso: number = 0;
  proceso_2: number = 0;

  async created() {
    await productoModule.getproductos();
  }

  get Productos_totales() {
    return productoModule.productos.length;
  }

  public Iniciar() {
    productoModule.extraerAmazon().then(() => {
      const interval = setInterval(() => {
        productoModule.extraerAmazonProceso().then((x: number) => {
          this.proceso = x;
          if (this.proceso === 0) {
            clearInterval(interval);
          }
        });
      }, 1000);
    });
  }

  public IniciarActualizacionPrecios() {
    productoModule.extraerAmazonPrecios().then(() => {
      const interval = setInterval(() => {
        productoModule.extraerAmazonProcesoPrecios().then((x: number) => {
          this.proceso_2 = x;
          if (this.proceso_2 === 0) {
            clearInterval(interval);
          }
        });
      }, 1000);
    });
  }
}
